import actions from 'redux-auto'
import i18n from 'i18next'
import {chain, find, groupBy} from 'lodash'
import Api from '#services/api'

const DEFAULT_RESULTSPERPAGE = 5
const DEFAULT_PAGENUMBER = 1

export function pending(state) {
  return {
    ...state,
  }
}

export function fulfilled(state, payload, result) {
  const {all} = state

  const concatinated = chain(all)
    .map(notification => find(result, res => res.id === notification.id) || notification)
    .concat(result)
    .uniqBy('id')
    .value()

  const grouped = groupBy(concatinated, 'hasBeenRead')

  return {
    ...state,
    all: concatinated,
    unread: grouped.false || [],
    read: grouped.true || [],
  }
}

export function rejected(state) {
  return {
    ...state,
  }
}

export async function action(payload) {
  const resultsPerPage = payload?.resultsPerPage || DEFAULT_RESULTSPERPAGE
  const pageNumber = payload?.pageNumber || DEFAULT_PAGENUMBER
  try {
    return await Api.getNotifications(resultsPerPage, pageNumber)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
